<template>
  <div id="userSettingsMain">
    <v-col class="">
      <v-row class="ma-0">
        <v-btn
          color="secondary"
          class="text-capitalize"
          @click="$router.go(-1)"
        >
          {{ $translate('BACK') }}
        </v-btn>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="10" xl="8">
          <v-card class="fill-height" style="min-height: 30em">
            <v-row class="fill-height ma-0 flex-nowrap">
              <!-- Side menu -->
              <v-navigation-drawer
                color="primary"
                dark
                :mini-variant="mini"
                permanent
              >
                <v-list-item two-line class="px-2">
                  <v-list-item-avatar>
                    <v-img :src="user.picture" />
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>
                      {{ user.firstName }}
                      {{ user.lastName }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-wrap">
                      {{ user.email }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-btn icon @click.stop="mini = !mini">
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                </v-list-item>

                <v-divider />

                <v-list dense>
                  <v-list-item
                    v-for="item in items"
                    :key="item.title"
                    link
                    @click="select(item)"
                    ripple
                  >
                    <v-list-item-icon>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                    <span class="overlay" v-if="selectedTab == item.title" />
                  </v-list-item>
                </v-list>

                <v-divider />

                <v-row justify="center" class="mt-10" v-if="!mini">
                  <QRCode :value="user.id" :options="{ width: 150 }" />
                </v-row>
                <v-row class="ma-10" justify="center">
                  <v-btn
                    color="red"
                    @click="checkForProductsInShoppingCart()"
                    dark
                    depressed
                    class="pa-4 ma-0"
                  >
                    <v-icon> mdi-logout </v-icon>
                    <a
                      class="text-capitalize hidden-sm-and-down text-decoration-none white--text"
                    >
                      {{ $translate('LOG_OUT') }}
                    </a>
                  </v-btn>
                </v-row>
              </v-navigation-drawer>

              <!--Content -->
              <activities v-if="selectedTab === $translate('MY_ORDERS')" />
              <UserSettingsFavourites
                v-if="selectedTab === $translate('FAVOURITES')"
              />
              <UserSettingsNotifications
                v-if="selectedTab === $translate('NOTIFICATIONS')"
              />
              <UserSettingsAccount
                :communicationPreferences="communicationPreferences[0].CommunicationTypes[0].CommunicationChannels"
                v-if="selectedTab === $translate('ACCOUNT_SETTINGS')"
              />
              <UserSettingsDutchStamps
                v-if="
                  selectedTab === $translate('DUTCHSTAMPS') &&
                  $store.getters['Account/partnerGroupDetails']
                    .ShowDutchStamps === true
                "
              />
              <UserSettingsCredits
                v-if="selectedTab === $translate('STORE_CREDIT')"
              />
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import doRequest from '@/api/dssRequest';
import UserObject from '@/objects/UserObject';
import UserSettingsAccount from './UserSettings_Account';
import UserSettingsInterests from './UserSettings_Interests';
import UserSettingsFavourites from './UserSettings_Favourites';
import UserSettingsNotifications from './UserSettings_Notifications';
import UserSettingsDutchStamps from './UserSettings_DutchStamps';
import UserSettingsCredits from './UserSettings_Credits';
import QRCode from '@chenfengyuan/vue-qrcode';
import Activities from '../activities/Activities';
import utility from '../../shared/utility';

export default {
  data() {
    return {
      selectedTab: this.$translate('MY_ORDERS'),
      mini: this.calculateMini(),
      items: [
        { title: this.$translate('MY_ORDERS'), icon: 'mdi-truck' },
        { title: this.$translate('FAVOURITES'), icon: 'favorite' },
        { title: this.$translate('NOTIFICATIONS'), icon: 'message' },
        { title: this.$translate('ACCOUNT_SETTINGS'), icon: 'person' },
        { title: this.$translate('STORE_CREDIT'), icon: 'euro_symbol' },
      ],
      communicationChannel:[],
    };
  },
  watch: {
    selectedTab() {
      this.getUserData();
    },
  },
  mounted() {
    this.getUserData();
    this.addStamps();
    if (this.$route.params.selectedTabFavourites === true)
      this.selectedTab = this.$translate('FAVOURITES');
    if (this.$route.params.selectedTabDutchStamps === true)
      this.selectedTab = this.$translate('DUTCHSTAMPS');
    if (this.$route.params.userSettings === true)
      this.selectedTab = this.$translate('ACCOUNT_SETTINGS');
    if (this.$route.params.myOrders === true)
      this.selectedTab = this.$translate('MY_ORDERS');
    if (this.$route.params.stamps === true)
      this.selectedTab = this.$translate('DUTCHSTAMPS');

    if (this.selectedTab == null || this.selectedTab === '') {
      this.selectedTab = this.$translate('MY_ORDERS');
    }
  },
  name: 'UserSettings',
  components: {
    UserSettingsDutchStamps,
    UserSettingsAccount,
    UserSettingsInterests,
    UserSettingsFavourites,
    UserSettingsNotifications,
    UserSettingsCredits,
    Activities,
    QRCode,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  created() {
    window.EventBus.listen('getUserData', this.getUserData);
  },
  beforeDestroy() {
    window.EventBus.removeListener('getUserData', this.getUserData);
  },
  updated() {
    // scroll to the right position on that page
    window.EventBus.fire('scrollToRightPosition', '#userSettingsMain');
  },
  methods: {
    addStamps() {
      const data = { title: this.$translate('DUTCHSTAMPS'), icon: 'ti-stamp' };
      if (
        this.$store.getters['Account/partnerGroupDetails'].ShowDutchStamps ===
        true
      ) {
        this.items.push(data);
      }
    },
    checkForProductsInShoppingCart() {
      // if you have products in your shoppingCart show alert dialog before logout
      if (this.$store.getters['shoppingCart/orders'].length !== 0) {
        // this.$emit('showLogoutAlert');
        window.EventBus.fire('showLogoutAlert');
      } else {
        this.logOut();
      }
    },
    logOut() {
      UserObject.logout();
      window.EventBus.fire(
        'activateSnackBar',
        this.$translate('SUCCESS_LOGGED_OUT')
      );

      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
    getUserData() {
      if (this.$store.getters['auth/userName'] === '') return;
      doRequest(
        (response) => {
          this.parsePartnerGroupUserRelations(response.data);
          this.parseUser(response.data);
          this.parseSubscriptions(response.data);
          this.parseUserRelationsAsChild(response.data);
          this.parseUserRelationsAsParent(response.data);
          this.communicationPreferences = response.data.CommunicationPreferences;
        },
        () => {},
        'getUserData',
        this.$store.getters['auth/userName'],
        this.createGetUserDataRequest()
      );
    },
    createGetUserDataRequest() {
      const requestObject = {
        RelationType: 'User',
        Id: this.$store.getters['auth/userName'],
        Types: {
          User: 'User',
        },
      };
      return requestObject;
    },
    parseUser(data) {
      this.$store.commit('auth/setDutchStamps', data.DutchStamps);
      this.$store.commit('auth/setUserCredits', data.UserCredits);
      this.$store.commit('auth/setUserSegments', data.SubScriptions);
      this.$store.commit('setFrontEndType', data.FrontEndType);
      const object = utility.createArrayWithObjects(data.UserData.User)[0];

      const user = {
        id: object.UserId,
        firstName: object.FirstName,
        lastName: object.LastName,
        street: object.Street,
        houseNo: object.Nr,
        city: object.City,
        postalCode: object.PostalCode,
        country: object.Country,
        countryCode: object.CountryCode,
        dob: object.DoB,
        picture: object.Picture,
        phoneNo: object.PhoneNumber,
        iban: object.IBAN,
        allowDirectDebit: object.AllowDirectDebit,
        accountHolderName: object.AccountHolderName,
        email: object.Email,
        latitude: object.Latitude,
        longitude: object.Longitude,
        professionalUser: object.ProfessionalUser,
        companyName: object.CompanyName,
        kvkNumber: object.KvKNumber,
        vatNumber: object.VATNumber,
      };
      this.$store.commit('auth/setUser', user);
    },
    parseSubscriptions(data) {
      this.$store.commit('auth/setSubscriptions', []);
      const subscriptionsArray = [];
      data.SubScriptions.forEach((subscription) => {
        if (subscription.Segments != null) {
          subscription.Segments.forEach((segment) => {
            subscriptionsArray.push({
              ...segment,
              PrimaryColor: subscription.PrimaryColor,
              SecondaryColor: subscription.SecondaryColor,
              Logo: subscription.Logo,
            });
          });
        }
      });
      this.$store.commit('auth/setSubscriptions', subscriptionsArray);
    },
    parseUserRelationsAsChild(data) {
      this.$store.commit('auth/setUserRelationsAsChild', {});
      let userRelationsAsChild = {};
      let shoppingList = [];
      if (
        data !== null &&
        data.hasOwnProperty('UserUserRelationsAsChild') &&
        data.UserUserRelationsAsChild.ShoppingLists != null
      ) {
        data.UserUserRelationsAsChild.ShoppingLists.forEach((list) => {
          let userData = {
            ChildEmailAddress: list.ChildEmailAddress,
            ChildUserId: list.ChildUserId,
            ParentEmailAddress: list.ParentEmailAddress,
            ParentUserId: list.ParentUserId,
            Type: list.Type,
          };
          shoppingList.push(userData);
        });
      }

      userRelationsAsChild = shoppingList;
      this.$store.commit('auth/setUserRelationsAsChild', userRelationsAsChild);
      console.log('userRelationsAsChild', userRelationsAsChild);
    },
    parseUserRelationsAsParent(data) {
      this.$store.commit('auth/setUserRelationsAsParent', {});
      let userRelationsAsParent = {};
      let shoppingList = [];
      if (
        data !== null &&
        data.hasOwnProperty('UserUserRelationsAsParent') &&
        data.UserUserRelationsAsParent.ShoppingLists != null
      ) {
        data.UserUserRelationsAsParent.ShoppingLists.forEach((list) => {
          let userData = {
            ChildEmailAddress: list.ChildEmailAddress,
            ChildUserId: list.ChildUserId,
            ParentEmailAddress: list.ParentEmailAddress,
            ParentUserId: list.ParentUserId,
            Type: list.Type,
          };
          shoppingList.push(userData);
        });
      }

      userRelationsAsParent = shoppingList;
      this.$store.commit(
        'auth/setUserRelationsAsParent',
        userRelationsAsParent
      );
      console.log('userRelationsAsParent', userRelationsAsParent);
    },
    parsePartnerGroupUserRelations(data) {
      this.$store.commit('auth/setPartnerGroupUserRelations', []);
      const partnerGroupUserRelationsArray = [];
      if (data.PartnerGroupUserRelations != null) {
        data.PartnerGroupUserRelations.forEach((relation) => {
          partnerGroupUserRelationsArray.push({
            Email: relation.Email,
            PartnerGroupId: relation.PartnerGroupId,
            UserId: relation.UserId,
            WhatsappMessagingAllowed: relation.WhatsappMessagingAllowed,
            SMSMessagingAllowed: relation.SMSMessagingAllowed,
            DeviceToken: relation.DeviceToken,
          });
        });
      }
      this.$store.commit(
        'auth/setPartnerGroupUserRelations',
        partnerGroupUserRelationsArray
      );
    },

    select(item) {
      console.log('selected ', item);
      this.selectedTab = item.title;
      this.mini = false;
    },
    calculateMini() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return true;
        case 'md':
        case 'lg':
        case 'xl':
        default:
          return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fill-height {
  height: 100% !important;
}
.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: white;
  opacity: 25%;
}
</style>
